import React, { useState, useEffect } from "react";
import { useI18nL10nContext } from "gatsby-plugin-i18n-l10n";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby"

import { Global } from "@emotion/react";
import { emotionGlobalCss } from "./styles";


export default function AreaSelector() {
  const languageContext = useI18nL10nContext();
  const [windowWidth, setWindowWidth] = useState<any>(typeof window !== 'undefined' && window.innerWidth);

  console.log("languageContext: ", languageContext);
  var zoom = windowWidth > 570 ? 1 : ((windowWidth - 320) / 625) + 0.6;

  const style = { position: 'absolute' as 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 500, zoom: zoom };

  useEffect(() => {
    if (typeof window !== "undefined") {
      const detectSize = () => setWindowWidth(window.innerWidth);
      console.log("window.innerWidth: ", window.innerWidth);
      window.addEventListener('resize', detectSize)
      return () => { window.removeEventListener('resize', detectSize); }
    } return;
  }, []);

  return (
    <>
      {languageContext.prefix === "main" ?
        <>
          <Global styles={emotionGlobalCss} />
          <Modal open={true} >
            <Card elevation={3} sx={style}>
              <CardHeader sx={{ textAlign: "center" }} title="Select Your Area  /  Choisissez Votre Région" />

              <CardContent sx={{ position: "relative" }}>
               
                  <StaticImage src={"../../images/NbMapLocation.jpg"} alt="" imgStyle={{ objectFit: "contain" }} />
                  {/* Edmundston */}
                  <Box width={35} position="absolute" top={75} left={75}>
                    <Link to="/edmundston/fr">
                      <StaticImage src={"../../images/mapMarker.png"} alt="" imgStyle={{ objectFit: "contain" }} />
                    </Link>
                    <Box sx={{ marginLeft: "-58px", width: "100px", textAlign: "center" }}>
                      <Typography sx={{ fontSize: "13px", textShadow: "1px 1px white,-1px 1px white,1px -1px white,-1px -1px white" }}>Edmundston</Typography>
                    </Box>
                  </Box>
                  {/* Grand Falls */}
                  {/* <Box width={35} position="absolute" top={115} left={115}>
                    <Link to="/grandfalls/en">
                      <StaticImage src={"../../images/mapMarker.png"} alt="" imgStyle={{ objectFit: "contain" }} />
                    </Link>
                    <Box sx={{ marginLeft: "-12px", width: "100px", textAlign: "center" }}>
                      <Typography sx={{ fontSize: "13px", textShadow: "1px 1px white,-1px 1px white,1px -1px white,-1px -1px white" }}>Grand Falls</Typography>
                    </Box>
                  </Box> */}
                  {/* Fredericton */}
                  <Box width={35} position="absolute" top={245} left={210}>
                    <Link to="/fredericton/en">
                      <StaticImage src={"../../images/mapMarker.png"} alt="" imgStyle={{ objectFit: "contain" }} />
                    </Link>
                    <Box sx={{ marginLeft: "-32px", width: "100px", textAlign: "center" }}>
                      <Typography sx={{ fontSize: "13px", textShadow: "1px 1px white,-1px 1px white,1px -1px white,-1px -1px white" }}>Fredericton</Typography>
                    </Box>
                  </Box>
                  {/* Moncton */}
                  <Box width={35} position="absolute" top={265} left={390}>
                    <Link to="/moncton/en">
                      <StaticImage src={"../../images/mapMarker.png"} alt="" imgStyle={{ objectFit: "contain" }} />
                    </Link>
                    <Box sx={{ marginLeft: "-42px", width: "100px", textAlign: "center" }}>
                      <Typography sx={{ fontSize: "13px", textShadow: "1px 1px white,-1px 1px white,1px -1px white,-1px -1px white" }}>Moncton</Typography>
                    </Box>
                  </Box>
                  {/* Saint John */}
                  <Box width={35} position="absolute" top={335} left={270}>
                    <Link to="/saintjohn/en">
                      <StaticImage src={"../../images/mapMarker.png"} alt="" imgStyle={{ objectFit: "contain" }} />
                    </Link>
                    <Box sx={{ marginLeft: "-32px", width: "100px", textAlign: "center" }}>
                      <Typography sx={{ fontSize: "13px", textShadow: "1px 1px white,-1px 1px white,1px -1px white,-1px -1px white" }}>Saint John</Typography>
                    </Box>
                  </Box>
                  {/* Miramichi */}
                  <Box width={35} position="absolute" top={120} left={315}>
                    <Link to="/miramichi/en">
                      <StaticImage src={"../../images/mapMarker.png"} alt="" imgStyle={{ objectFit: "contain" }} />
                    </Link>
                    <Box sx={{ marginLeft: "-32px", width: "100px", textAlign: "center" }}>
                      <Typography sx={{ fontSize: "13px", textShadow: "1px 1px white,-1px 1px white,1px -1px white,-1px -1px white" }}>Miramichi</Typography>
                    </Box>
                  </Box>
                  {/* Bathurst */}
                  <Box width={35} position="absolute" top={45} left={300}>
                    <Link to="/bathurst/en">
                      <StaticImage src={"../../images/mapMarker.png"} alt="" imgStyle={{ objectFit: "contain" }} />
                    </Link>
                    <Box sx={{ marginLeft: "-52px", width: "100px", textAlign: "center" }}>
                      <Typography sx={{ fontSize: "13px", textShadow: "1px 1px white,-1px 1px white,1px -1px white,-1px -1px white" }}>Bathurst</Typography>
                    </Box>
                  </Box>
                  {/* Shippagan */}
                  <Box width={35} position="absolute" top={28} left={383}>
                    <Link to="/shippagan/fr">
                      <StaticImage src={"../../images/mapMarker.png"} alt="" imgStyle={{ objectFit: "contain" }} />
                    </Link>
                    <Box sx={{ marginLeft: "-26px", width: "100px", textAlign: "center" }}>
                      <Typography sx={{ fontSize: "13px", textShadow: "1px 1px white,-1px 1px white,1px -1px white,-1px -1px white" }}>Shippagan</Typography>
                    </Box>
                  </Box>
                  {/* Campbellton */}
                  <Box width={35} position="absolute" top={-5} left={230}>
                    <Link to="/campbellton/fr">
                      <StaticImage src={"../../images/mapMarker.png"} alt="" imgStyle={{ objectFit: "contain" }} />
                    </Link>
                    <Box sx={{ marginLeft: "-32px", width: "100px", textAlign: "center" }}>
                      <Typography sx={{ fontSize: "13px", textShadow: "1px 1px white,-1px 1px white,1px -1px white,-1px -1px white" }}>Campbellton</Typography>
                    </Box>
                  </Box>
                
              </CardContent>
            </Card>
          </Modal>
        </>
        : <></>}
    </>

  )
};